export default {
  computed: {
    getLabelTitleErrorMessage() {
      const prefix = this.i18nPrefix || 'LABEL_MGMT';
      let errorMessage = '';
      if (!this.$v.title.$error) {
        errorMessage = '';
      } else if (!this.$v.title.required) {
        errorMessage = this.$t(`${prefix}.FORM.NAME.REQUIRED_ERROR`);
      } else if (!this.$v.title.minLength) {
        errorMessage = this.$t(`${prefix}.FORM.NAME.MINIMUM_LENGTH_ERROR`);
      } else if (!this.$v.title.validLabelCharacters) {
        errorMessage = this.$t(`${prefix}.FORM.NAME.VALID_ERROR`);
      }
      return errorMessage;
    },
  },
};
